import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.uiActionRendering.DOC}
  mutation TestMosaicAction(
    $tenantId: ID!
    $zoneId: ID!
    $actionIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          testAction(identifier: $actionIdentifier) {
            ...FragmentMosaicUiActionRendering
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.TestMosaicActionMutation,
    readonly ents.core.mosaic.Action.Rendering.OfUiOperationsOnly[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicDev',
        graphql.transformers.OUT.select(
          'testAction',
          graphql.transformers.OUT.list(
            fragments.uiActionRendering.TRANSFORMER,
            {
              onNullish: 'remove',
            },
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.TestMosaicActionMutation,
  readonly ents.core.mosaic.Action.Rendering.OfUiOperationsOnly[],
  graphql.schema.TestMosaicActionMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
